import styled, { css } from "styled-components";

// import downarrow from "../../assets/img/down-arrow-svgrepo-com.svg";
import {
	appearAnimation,
	disappearAnimation,
} from "../../assets/styles/Animations";

export const StyledSelect = styled.div<{
	togglelist: any;
	bottompos: any;
	transform: any;
}>`
	position: relative;

	.selectContainer {
		cursor: pointer;
		width: 100%;
		font-size: 1.2rem;
		outline: none;
		/* color: var(--color-text); */
		background-color: var(--color-brand-2);
		border: 1px solid transparent;
		border-radius: var(--radius);

		position: relative;

		transition: all 0.3s ease;

		&:focus {
			border: 1px solid var(--color-gray-10);
		}

		input {
			pointer-events: none;
			margin-bottom: 0;
			display: block;
			padding: 0.8rem;
			width: 100%;
			height: 100%;
			border: 1px solid transparent;
			border-radius: var(--radius-1);
			font-weight: var(--fw-semibold);
			color: var(--color-gray-3);
			background-color: transparent;
		}

		input:focus {
			outline: none;
			border: 1px solid var(--color-gray-2);
		}

		ul {
			${({ togglelist }: any) => {
				return togglelist
					? css`
							display: flex;
							animation: ${appearAnimation} 0.3s ease;
					  `
					: css`
							display: none;
							animation: ${disappearAnimation} 0.3s ease;
					  `;
			}}
			flex-direction: column;

			width: 100%;
			max-height: 177px;
			overflow-y: auto;
			position: absolute;
			${({ bottompos }: any) => {
				return bottompos >= 200
					? css`
							top: 37px;
					  `
					: css`
							top: -170px;
					  `;
			}}
			left: 0;
			background-color: var(--color-brand-2);

			li {
				text-align: center;
				padding: 1.4rem 0;
				width: 100%;
				border-bottom: 1px solid var(--color-gray-0);

				transition: all 0.3s ease;

				img {
					width: 30px;
					height: 30px;
				}
			}

			li:hover {
				cursor: pointer;
				background-color: var(--color-brand-1);
			}
		}
	}

	span {
		display: block;
		position: absolute;
		top: 17px;
		right: 17px;
		height: 100%;
		width: 1.4rem;
		pointer-events: none;

		filter: invert(57%) sepia(9%) saturate(332%) hue-rotate(169deg)
			brightness(96%) contrast(91%);

		transition: all 0.3s ease;

		/* transform logic */
		${({ transform }: any) => {
			return transform
				? css`
						transform: rotateX(-180deg) rotateY(180deg) rotateY(180deg)
							translateY(34px);
				  `
				: css`
						transform: rotateX(0);
				  `;
		}}
	}
`;
/* background: url(${downarrow}) no-repeat; */
